import type { RootState } from '../reducers/rootReducer.ts';
import { chartNodes } from './scenarioChartSelectors.ts';

export const intentEditingOpen = (state: RootState) =>
  !!state.scenarioChartReducer.selected && state.scenarioChartReducer.selected.type === 'node';

export const intentInEditing = (state: RootState) =>
  intentEditingOpen(state) ? chartNodes(state)[state.scenarioChartReducer.selected.id!] : undefined;
